enum IconBlockNotePresentation {
	TEXTE = 'Text',
	GRAPHIQUE = 'BarChart4',
	TABLEAU = 'Table2',
	CHAMP_LIBRE = 'NotebookPen',
	RATIO = 'RemoveFormatting',
	AUTRE = 'CircleHelp',
}

export default IconBlockNotePresentation;
